import { createSelector } from 'reselect';

const getAppContextConfig = (state) => {
    const { views: { view }, config = {} } = state;
    return config[view]?.appContext ?? config?.appContext ?? 'mlb';
};

export const getAppContextConfigState = createSelector(
    [getAppContextConfig],
    (appContext) => {
        return appContext;
    }
);
